import { Alert, Checkbox, Image, Modal, Radio, Select } from "antd"
import React, { useEffect, useState } from "react"
import OTPInput from "otp-input-react";
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import ArrowIcon from "../assets/images/ArrowIconWhite.svg"
import { LoadingOutlined } from "@ant-design/icons"
import { isAlphabets, isCustomEnrollId, isPdf, isValidEmail, prescriptionContents, uploadFileInfo, validateUPI } from "../utilities"
import {
  getAllRegionsOfIndiaService,
  getAllSpecialitiesService,
  otpVerificationService,
  sendOtpService,
  userAdditionalFieldService,
  userCreateService
} from "../services/apiServices"
import { MdClose, MdOutlineAttachFile, MdVerified, MdInfoOutline, MdOutlineClose } from "react-icons/md"
import { IoMdCloseCircle } from "react-icons/io"
import TickIcon from "../assets/images/TickIconGreen.svg"
import UserBankDetailsForm from "./UserBankDetailsForm"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import PdfImg from '../assets/images/pdf-placeholder.jpg'

const { Option } = Select

export const PAYMENT_OPTIONS = {
  UPI: 1,
  BANK: 2,
  CHEQUE: 3
}

function UserDetailsForm({
  otpErrorMessage,
  isEmail,
  parentData,
  userDetailsRef,
  userId,
  setUserId,
  directPrescription,
  metarxDetails
}) {
  const [otp, setOtp] = useState("")
  const [formValue, setFormValue] = useState("")
  const [formsData, setFormsData] = useState({
    firstName: "",
    lastName: "",
    qualification: "",
    speciality: null,
    medicalCouncil: null,
    registrationNumber: "",
  })
  const [loading, setLoading] = useState(false)
  const [showOtp, setShowOtp] = useState(false)
  const [otpStatus, setOtpStatus] = useState(1)
  const [userCreateErrorMessage, setUserCreateErrorMessage] = useState("")
  const [showAdditionalFields, setShowAdditionalFields] = useState(false)
  const [files, setFiles] = useState({})
  const [upiId, setUpiId] = useState("")
  const [checked, setChecked] = useState(false)
  const [additionalFieldSubmitLoading, setAdditionalFieldSubmitLoading] = useState(false)
  const [additionalFieldsSubmitErrorMessage, setAdditionalFieldsSubmitErrorMessage] = useState("")
  const [openPrescriptionModal, setOpenPrescriptionModal] = useState(false)
  const [allSpecialities, setAllSpecialities] = useState([])
  const [allRegionsOfIndia, setAllRegionsOfIndia] = useState([])
  const [upiErrorMessage, setUpiErrorMessage] = useState("")
  const [paymentChecked, setPaymentChecked] = useState(undefined)
  const [bankFromsData, setBankFormsData] = useState({
    bankName: "",
    bankAccountName: "",
    accountNumber: "",
    ifscCode: ""
  })
  const [accountNumberError, setAccountNumberError] = useState("")

  const [prescriptions, setPrescriptions] = useState([])
  const [pdfUrl, setPdfUrl] = useState('')
  const [openPdfViewModal, setOpenPdfViewModal] = useState(false)
  const [verifyOtpLoading, setVerifyOtpLoading] = useState(false)

  const { metarxId } = useParams()

  let userName = localStorage.getItem("userName")
  let isPanCardRequired = localStorage.getItem("isPanCardRequired") && localStorage.getItem("isPanCardRequired") === "true"

  const sendOtp = () => {
    setLoading(true)
    const payload = isEmail ? { email: parentData.trim(), metarxId: metarxId } : { mobileNumber: parentData.trim().substring(2), metarxId: metarxId }
    payload.validRequest = true
    sendOtpService(payload)
      .then((response) => {
        if (response.hasUploaded) {
          window.location.reload()
        } else {
          setUserId(response.userId)
          localStorage.setItem("userName", response.userName)
          localStorage.setItem("isPanCardRequired", response.isPanCardRequired)
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const handleUserCreate = () => {
    setLoading(true)
    const payload = isEmail
      ? {
        metarxId: metarxId,
        firstName: formsData.firstName.trim(),
        lastName: formsData.lastName.trim(),
        email: parentData.trim(),
        mobileNumber: formValue.substring(2),
        qualification: formsData.qualification.trim(),
        speciality: formsData.speciality,
        medicalCouncil: formsData.medicalCouncil,
        registrationNumber: formsData.registrationNumber.trim(),
      }
      : {
        metarxId: metarxId,
        firstName: formsData.firstName.trim(),
        lastName: formsData.lastName.trim(),
        email: formValue.trim(),
        mobileNumber: parentData.substring(2),
        qualification: formsData.qualification.trim(),
        speciality: formsData.speciality,
        medicalCouncil: formsData.medicalCouncil,
        registrationNumber: formsData.registrationNumber.trim(),
      }

    userCreateService(payload)
      .then((response) => {
        setLoading(false)
        setShowOtp(true)
        setUserId(response.userId)
        localStorage.setItem("userName", response.userName)
        localStorage.setItem("isPanCardRequired", response.isPanCardRequired)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response?.data?.message) {
          setUserCreateErrorMessage(error.response.data.message)
        }
      })
  }

  const validateForm = () => {
    return (
      !formsData.firstName ||
      !formsData.firstName.trim() ||
      !formsData.lastName ||
      !formsData.lastName.trim() ||
      !formValue ||
      !formValue.trim() ||
      !formsData.qualification ||
      !formsData.qualification.trim() ||
      !formsData.speciality ||
      !formsData.medicalCouncil ||
      !formsData.registrationNumber ||
      !formsData.registrationNumber.trim() ||
      (!isEmail ? !formValue || !isValidEmail(formValue) : !formValue || formValue.length < 12)
    )
  }

  const validateBankForm = () => {
    if (metarxDetails.isBankDetailsRequired && paymentChecked === PAYMENT_OPTIONS.BANK) {
      return !bankFromsData.bankName || !bankFromsData.bankAccountName || !bankFromsData.accountNumber || bankFromsData.accountNumber.length < 9 || bankFromsData.accountNumber.length > 18 || bankFromsData.accountNumber !== bankFromsData.confirmAccountNumber || !bankFromsData.ifscCode || bankFromsData.ifscCode.length < 11
    }
  }

  useEffect(() => {
    if (otpStatus === 3 && showAdditionalFields) {
      localStorage.setItem("userId", userId)
    }
  }, [otpStatus, showAdditionalFields])

  useEffect(() => {
    getAllSpecialities()
    getAllRegionsOfIndia()
  }, [])

  const handleVerifyOtp = () => {
    if (otp.length === 6 && userId) {
      setVerifyOtpLoading(true)
      setOtpStatus(2)
      const payload = {
        userId,
        otp,
        validRequest: true
      }
      otpVerificationService(payload)
        .then((response) => {
          setOtpStatus(3)
          setVerifyOtpLoading(false)
        })
        .catch((error) => {
          setOtpStatus(4)
          setVerifyOtpLoading(false)
        })
    }
  }

  const handleMultipleFilesUpload = (ev, name) => {
    let files = Array.from(ev.target.files)
    if (files.length > 0) {
      const filesArr = files.filter(items => items.type === 'image/jpeg' || items.type === 'image/png' || items.type.includes('pdf'))
      setPrescriptions([...prescriptions, ...filesArr])
    }
  }

  const handleFilesUpload = (ev, name) => {
    let file = ev.target.files[0]
    if (file) {
      setAdditionalFieldsSubmitErrorMessage("")
      setFiles({ ...files, [name]: { fileName: file.name, file: file, fileUrl: URL.createObjectURL(file) } })
    }
  }

  const getAppropriateObject = (fileName, fileUrl, customHeight = "400") => {
    return isPdf(fileName) ? (
      <iframe src={fileUrl + "#toolbar=0&navpanes=0&scrollbar=0&view=FitH"}
        className={`width-full height-${customHeight}`} title="PDF Viewer" />
    ) : (
      <Image src={fileUrl} style={{ borderRadius: "12px" }} preview={false} className="width-full height-full" />
    )
  }

  const handleChecked = (e) => {
    setChecked(e.target.checked)
    setShowAdditionalFields(true)
  }

  const handleAdditionalFieldsSubmit = () => {
    if (paymentChecked === PAYMENT_OPTIONS.UPI && !validateUPI(upiId)) {
      setUpiErrorMessage("Please enter valid UPI ID")
      return
    }
    setAdditionalFieldSubmitLoading(true)
    const formData = new FormData()
    if (prescriptions.length > 0) {
      for (let i = 0; i < prescriptions.length; i++) {
        formData.append("prescriptions", prescriptions[i])
      }
    }
    if (files.cheque?.file) {
      formData.append("cheque", files.cheque.file)
    }
    if (isPanCardRequired && files.pan?.file) {
      formData.append("panCard", files.pan.file)
    }
    let payload = paymentChecked === PAYMENT_OPTIONS.BANK ? bankFromsData : PAYMENT_OPTIONS.UPI ? { upiId: upiId } : {}
    payload.metarxId = metarxId
    formData.append(
      "prescriptionUserAddFieldRequest",
      new Blob([JSON.stringify(payload)], {
        type: "application/json",
      })
    )
    userAdditionalFieldService(userId, formData)
      .then((response) => {
        setAdditionalFieldSubmitLoading(false)
        setOpenPrescriptionModal(true)
        localStorage.clear()
      })
      .catch((error) => {
        setAdditionalFieldSubmitLoading(false)
        if (error.response?.data?.message) {
          setAdditionalFieldsSubmitErrorMessage(error.response?.data?.message)
        }
      })
  }

  const handleFormsData = (ev) => {
    const { name, value } = ev.target
    setFormsData({ ...formsData, [name]: value })
  }

  const handleChangeSelection = (value, name) => {
    setFormsData({ ...formsData, [name]: value })
  }

  const handleChangeUpiId = (ev) => {
    setUpiErrorMessage("")
    setUpiId(ev.target.value)
  }

  const handleClose = () => {
    window.location.reload()
    setOpenPrescriptionModal(false)
  }

  const getAllSpecialities = () => {
    getAllSpecialitiesService()
      .then((response) => setAllSpecialities(response.specialities))
      .catch((error) => console.error(error))
  }

  const getAllRegionsOfIndia = () => {
    getAllRegionsOfIndiaService()
      .then((response) => setAllRegionsOfIndia(response.regions))
      .catch((error) => console.error(error))
  }

  const handleBankFormsData = (ev) => {
    const { name, value } = ev.target
    if (name === 'accountNumber' || name === 'confirmAccountNumber') {
      const newValue = value.replace(/[^0-9]/g, "");
      setBankFormsData({ ...bankFromsData, [name]: newValue })
    } else if (name === 'ifscCode') {
      const newValue = value.replace(/[^a-zA-Z0-9]/g, "");
      setBankFormsData({ ...bankFromsData, [name]: newValue })
    } else {
      setBankFormsData({ ...bankFromsData, [name]: value })
    }
  }

  const handleAccountNumberBlur = () => {
    if (bankFromsData.confirmAccountNumber?.length >= 9) {
      if (bankFromsData.accountNumber !== bankFromsData.confirmAccountNumber) {
        setAccountNumberError("Account Numbers does not matching!")
      } else {
        setAccountNumberError("")
      }
    }
  }

  const handleRemoveMedia = (items) => {
    const filteredFilesList = prescriptions.filter(
      (item) => item.lastModified !== items.lastModified
    )
    setPrescriptions(filteredFilesList)
  }

  const handlePaymentMode = (checked) => {
    setFiles({})
    setPaymentChecked(checked)
  }

  const handleOpenPdfViewModal = (items) => {
    setPdfUrl(URL.createObjectURL(items))
    setOpenPdfViewModal(true)
  }

  const handleClosePdfViewModal = () => {
    setPdfUrl('')
    setOpenPdfViewModal(false)
  }

  const paymentModeSelection = (metarxDetails.isUpiIdRequired || metarxDetails.isBankDetailsRequired) && <div className="payment-options-wrapper">
    <div className="payment-options-label">Payment Mode</div>
    <div className="payment-options">
      {metarxDetails.isUpiIdRequired && <Radio checked={paymentChecked === PAYMENT_OPTIONS.UPI} onChange={() => handlePaymentMode(PAYMENT_OPTIONS.UPI)} style={{ fontSize: 16, }}>UPI ID</Radio>}
      {metarxDetails.isBankDetailsRequired && <Radio checked={paymentChecked === PAYMENT_OPTIONS.BANK} onChange={() => handlePaymentMode(PAYMENT_OPTIONS.BANK)} style={{ fontSize: 16, }}>Bank Details</Radio>}
      {metarxDetails.isBankDetailsRequired && <Radio checked={paymentChecked === PAYMENT_OPTIONS.CHEQUE} onChange={() => handlePaymentMode(PAYMENT_OPTIONS.CHEQUE)} style={{ fontSize: 16, }}>Blank Cheque</Radio>}
    </div>
  </div>

  return (
    <div ref={userDetailsRef} className="user-details-form-container">
      {otpErrorMessage !== "" && <Alert message={otpErrorMessage} type="warning" showIcon />}
      {otpErrorMessage ? (
        <div className="user-details-form" style={userId ? { cursor: "no-drop", opacity: 0.5 } : {}}>
          <div className="form-items">
            <label>First Name</label>
            <input type="text" placeholder="Enter first name" name="firstName" value={formsData.firstName}
              onChange={handleFormsData} onKeyDown={isAlphabets} className="form-controls" />
          </div>
          <div className="form-items">
            <label>Last Name</label>
            <input type="text" placeholder="Enter last name" name="lastName" value={formsData.lastName}
              onChange={handleFormsData} onKeyDown={isAlphabets} className="form-controls" />
          </div>
          {isEmail ? (
            <div className="form-items">
              <label>Mobile Number</label>
              <div style={{ position: "relative" }} className="mobile-form-controls">
                <PhoneInput country={"in"} countryCodeEditable={false} disableDropdown={true}
                  value={formValue} onChange={setFormValue}
                  placeholder="Enter mobile number" />
                {!formValue && <span className="place-holder-text">Enter mobile number</span>}
              </div>
            </div>
          ) : (
            <div className="form-items">
              <label>Email Address</label>
              <input type="email" placeholder="Enter email address" value={formValue}
                onChange={(ev) => setFormValue(ev.target.value)} className="form-controls" />
            </div>
          )}
          <div className="form-items">
            <label>Qualification</label>
            <input type="text" placeholder="Enter qualification" name="qualification"
              value={formsData.qualification} onChange={handleFormsData} onKeyDown={isAlphabets} className="form-controls" />
          </div>
          <div className="form-items">
            <label>Speciality</label>
            <Select
              allowClear
              showSearch
              placeholder="Select a speciality"
              optionFilterProp="children"
              className="form-controls"
              onChange={(value) => handleChangeSelection(value, "speciality")}
              filterOption={(input, option) => (option?.children ?? "").toLowerCase().includes(input.toLowerCase())}
            >
              {allSpecialities.map((items, index) => {
                return (
                  <Option key={index} value={items.name}>
                    {items.name}
                  </Option>
                )
              })}
            </Select>
          </div>
          <div className="form-items">
            <label>Medical Council</label>
            <Select
              allowClear
              showSearch
              placeholder="Select a medical council"
              optionFilterProp="children"
              className="form-controls"
              onChange={(value) => handleChangeSelection(value, "medicalCouncil")}
              filterOption={(input, option) => (option?.children ?? "").toLowerCase().includes(input.toLowerCase())}
            >
              {allRegionsOfIndia.map((items, index) => {
                return (
                  <Option key={index} value={items.name}>
                    {items.name}
                  </Option>
                )
              })}
            </Select>
          </div>
          <div className="form-items">
            <label>Registration Number</label>
            <input type="text" placeholder="Enter Registration Number" name="registrationNumber" value={formsData.registrationNumber}
              onChange={handleFormsData} className="form-controls" />
          </div>
          <div className="form-items">
            <label className="empty-label">&nbsp;</label>
            <button onClick={handleUserCreate} disabled={validateForm()}
              className="bookDemoButton bookDemoButtonBlue submit-button">
              Continue to verify {loading ? <LoadingOutlined style={{ marginLeft: 16 }} /> :
                <img src={ArrowIcon} alt />}
            </button>
          </div>
        </div>
      ) : directPrescription ? (
        ""
      ) : (
        <div>
          <Alert style={{ marginTop: 16 }} message={`An SMS and email with your OTP have been sent. Please enter it to verify.`}
            type="success" showIcon />
          <div className="otp-controls">
            <OTPInput value={otp} onChange={setOtp} autoFocus OTPLength={6} otpType="number" disabled={otpStatus === 3} />
            {otpStatus > 1 && (
              <div style={{ fontSize: "14px", display: "flex" }}>
                {otpStatus === 2 ? (
                  <LoadingOutlined style={{ marginLeft: 16 }} />
                ) : otpStatus === 3 ? (
                  <div className={"otp-status"} style={{ color: "green" }}>
                    <span>Verified</span>
                    <MdVerified style={{ marginLeft: 8 }} />
                  </div>
                ) : (
                  <>
                    <div className={"otp-status"} style={{ color: "red" }}>
                      <span>Incorrect</span>
                      <IoMdCloseCircle style={{ marginLeft: 8 }} />
                    </div>
                    <button onClick={sendOtp} className="green-button" style={{ marginTop: 8 }}>
                      Re-send OTP {loading ? <LoadingOutlined style={{ marginLeft: 16 }} /> :
                        <img src={ArrowIcon} alt />}
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
          <div>
            <Checkbox value={checked} onChange={handleChecked}
              disabled={otpStatus === 3 && showAdditionalFields} style={{ marginRight: 8 }}>
              I hereby acknowledge that I have read, understood, and agree to the{" "}
              <a href="/regional-ambassador-agreement" target="_blank" rel="noopener noreferrer"
                style={{ fontWeight: "500" }}>
                Regional Ambassador Agreement
              </a>
              .
            </Checkbox>
          </div>
          <button disabled={!checked || otp.length < 6 || verifyOtpLoading || otpStatus === 3} onClick={handleVerifyOtp} className="bookDemoButton bookDemoButtonBlue submit-button" style={{ marginTop: 20 }}>Submit {verifyOtpLoading ? <LoadingOutlined style={{ marginLeft: 16 }} /> :
            <img src={ArrowIcon} alt='' />}</button>
        </div>
      )}

      {!otpErrorMessage ? null : userCreateErrorMessage !== "" ? (
        <Alert message={userCreateErrorMessage} type="error" showIcon />
      ) : showOtp ? (
        <div>
          <Alert message={`An SMS and email with your OTP have been sent. Please enter it to verify.`}
            type="success" showIcon />
          <div className="otp-controls">
            <OTPInput value={otp} onChange={setOtp} autoFocus OTPLength={6} otpType="number" disabled={otpStatus === 3} />
            {otpStatus > 1 && (
              <div style={{ fontSize: "14px" }}>
                {otpStatus === 2 ? (
                  <LoadingOutlined style={{ marginLeft: 16 }} />
                ) : otpStatus === 3 ? (
                  <div className={"otp-status"} style={{ color: "green" }}>
                    <span>Verified</span>
                    <MdVerified style={{ marginLeft: 8 }} />
                  </div>
                ) : (
                  <div className={"otp-status"} style={{ color: "red" }}>
                    <span>Incorrect</span>
                    <IoMdCloseCircle style={{ marginLeft: 8 }} />
                    <button onClick={sendOtp} className="green-button">
                      Re-send OTP {loading ? <LoadingOutlined style={{ marginLeft: 16 }} /> :
                        <img src={ArrowIcon} alt />}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          <div>
            <Checkbox onChange={handleChecked} disabled={otpStatus === 3 && showAdditionalFields}
              style={{ marginRight: 8 }}>
              I hereby acknowledge that I have read, understood, and agree to the{" "}
              <a href="/regional-ambassador-agreement" target="_blank" rel="noopener noreferrer"
                style={{ fontWeight: "500" }}>
                Regional Ambassador Agreement
              </a>
              .
            </Checkbox>
          </div>
          <button disabled={!checked || otp.length < 6 || verifyOtpLoading || otpStatus === 3} onClick={handleVerifyOtp} className="bookDemoButton bookDemoButtonBlue submit-button" style={{ marginTop: 20 }}>Submit {verifyOtpLoading ? <LoadingOutlined style={{ marginLeft: 16 }} /> :
            <img src={ArrowIcon} alt='' />}</button>
        </div>
      ) : null}

      {((otpStatus === 3 && showAdditionalFields) || directPrescription) && (
        <div className={"upload-section"}>
          {isCustomEnrollId(metarxId) ? null : userName && (
            <h4>
              Dear <span className="blue-text">{userName}</span>, we sincerely appreciate your valuable
              time and participation in the
            </h4>
          )}
          {isCustomEnrollId(metarxId) ? null : <div className={"section-heading"}>{prescriptionContents.prescriptionAudit}</div>}
          <div className="user-details-form user-details-form-prescription" style={{ marginTop: isCustomEnrollId(metarxId) ? 0 : '' }}>
            <div className="file-upload">
              <div className="file-upload-label-text"
                style={files.file ? { color: "green", display: "flex", alignItems: "center" } : {}}>
                <span>Prescriptions Upload {uploadFileInfo()} {!isCustomEnrollId(metarxId) && metarxDetails.minimumPrescriptions && <span style={{ opacity: 0.6, fontWeight: 400, fontSize: 12, fontStyle: 'italic' }}>(minimum {metarxDetails.minimumPrescriptions} images)</span>}</span> {files.file && <MdVerified style={{ marginLeft: 8 }} />}
              </div>
              <input type="file" id="upload-prescription" multiple="multiple"
                accept=".jpg,.jpeg,.png,.pdf" hidden
                onChange={(ev) => handleMultipleFilesUpload(ev, "file")} />
              <label style={{ display: "flex", alignItems: "center" }} for="upload-prescription">
                <MdOutlineAttachFile style={{ fontSize: "16px", marginRight: 4 }} /> Choose Prescriptions
              </label>
              <div style={{ fontSize: 12, fontStyle: 'italic', opacity: 0.6, marginTop: 5, }}><MdInfoOutline style={{ marginRight: 5, verticleAlign: 'text-top' }} />Please upload images (png , jpg) or pdf files.</div>
              {prescriptions.length > 0 && (
                <div className="uploaded-files">
                  {prescriptions.map((items, index) => {
                    return (
                      <div key={index} className="uploaded-file">
                        {isPdf(items.name) ? (
                          <img
                            src={PdfImg}
                            alt={items.name}
                            className=""
                            onClickCapture={() => handleOpenPdfViewModal(items)}
                          />
                        ) : (
                          <Image
                            loading="lazy"
                            src={URL.createObjectURL(items)}
                            alt={items.name}
                            className=""
                          />
                        )}
                        <button
                          onClick={() => handleRemoveMedia(items)}
                          className="remove-media-button"
                        >
                          <MdOutlineClose />
                        </button>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
            {isPanCardRequired && (
              <div className="file-upload">
                <div className="file-upload-label-text"
                  style={files.pan ? { color: "green", display: "flex", alignItems: "center" } : {}}>
                  <span>PAN Upload {uploadFileInfo()}</span> {files.pan && <MdVerified style={{ marginLeft: 8 }} />}
                </div>
                <input type="file" id="upload-pan" accept=".jpg,.jpeg,.png,.pdf" hidden
                  onChange={(ev) => handleFilesUpload(ev, "pan")} />
                <label style={{ display: "flex", alignItems: "center" }} for="upload-pan">
                  <MdOutlineAttachFile style={{ fontSize: "16px", marginRight: 4 }} /> Choose PAN
                </label>
                {files.pan?.file && (
                  <div className="uploaded-files">
                    <div className="uploaded-file">
                      {isPdf(files.pan.fileName) ? (
                        <img
                          src={PdfImg}
                          alt={files.pan.fileName}
                          className=""
                          onClickCapture={() => handleOpenPdfViewModal(files.pan.file)}
                        />
                      ) : (
                        <Image
                          loading="lazy"
                          src={URL.createObjectURL(files.pan.file)}
                          alt={files.pan.fileName}
                          className=""
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            {paymentModeSelection}

            {paymentChecked === PAYMENT_OPTIONS.BANK ?
              <UserBankDetailsForm bankFromsData={bankFromsData} handleBankFormsData={handleBankFormsData}
                accountNumberError={accountNumberError}
                handleAccountNumberBlur={handleAccountNumberBlur}
                setPaymentChecked={handlePaymentMode} paymentModeSelection={paymentModeSelection} /> :
              paymentChecked === PAYMENT_OPTIONS.UPI ? <div className="form-items">
                <label style={{ display: 'flex', alignItems: 'center' }}>UPI ID</label>
                <input type="text" placeholder="Enter UPI ID"
                  className="form-controls" value={upiId} onChange={handleChangeUpiId} />
                {upiErrorMessage !== "" &&
                  <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>{upiErrorMessage}</div>}
              </div> : paymentChecked === PAYMENT_OPTIONS.CHEQUE ? <div className="file-upload">
                <div className={'file-upload-label-text'}
                  style={{ display: 'flex', alignItems: 'center' }}>Upload Cheque {uploadFileInfo()}
                </div>
                <input type="file" id="upload-pan" accept=".jpg,.jpeg,.png,.pdf" hidden
                  onChange={(ev) => handleFilesUpload(ev, "cheque")} />
                <label style={{ display: "flex", alignItems: "center" }} htmlFor="upload-pan">
                  <MdOutlineAttachFile style={{ fontSize: "16px", marginRight: 4 }} /> Choose File
                </label>
                {files.cheque?.file && (
                  <div className="uploaded-files">
                    <div className="uploaded-file">
                      {isPdf(files.cheque.fileName) ? (
                        <img
                          src={PdfImg}
                          alt={files.cheque.fileName}
                          className=""
                          onClickCapture={() => handleOpenPdfViewModal(files.cheque.file)}
                        />
                      ) : (
                        <Image
                          loading="lazy"
                          src={URL.createObjectURL(files.cheque.file)}
                          alt={files.cheque.fileName}
                          className=""
                        />
                      )}
                    </div>
                  </div>
                )}
              </div> : null}
          </div>
          <div className="form-items">
            <label className="empty-label">&nbsp;</label>
            <button
              onClick={handleAdditionalFieldsSubmit}
              disabled={prescriptions.length === 0 || (isPanCardRequired && !files.pan) || (metarxDetails.isBankDetailsRequired && paymentChecked === PAYMENT_OPTIONS.CHEQUE && !files.cheque) || (metarxDetails.isUpiIdRequired && paymentChecked === PAYMENT_OPTIONS.UPI && !upiId.trim()) || validateBankForm()}
              className="bookDemoButton bookDemoButtonBlue submit-button"
            >
              {(metarxDetails.isUpiIdRequired || metarxDetails.isBankDetailsRequired) ? 'Submit' : 'Upload'} {additionalFieldSubmitLoading ? <LoadingOutlined style={{ marginLeft: 16 }} /> :
                <img src={ArrowIcon} alt />}
            </button>
          </div>
          {additionalFieldsSubmitErrorMessage !== "" &&
            <Alert style={{ marginTop: 16 }} message={additionalFieldsSubmitErrorMessage} type="error" showIcon />}
          <div style={{ marginTop: 16, display: 'none' }}>
            <span style={{ fontWeight: "bold", color: "#1E88C9" }}>Note : </span>
            Kindly upload a patient prescription for <span style={{ fontWeight: "bold", color: "#1E88C9" }}>infection treatment</span>,
            and provide your UPI ID to facilitate the processing of the honorarium.
          </div>
        </div>
      )}
      <Modal title={""} footer={null} visible={openPrescriptionModal} onOk={handleClose} onCancel={handleClose}
        closeIcon={<MdClose />} width={370} centered>
        <section className="thankYouMessage">
          <img src={TickIcon} alt="" />
          <h2>Thank you for submitting the prescription!</h2>
        </section>
      </Modal>

      <Modal title={"PDF Preview"} footer={null} visible={openPdfViewModal} onOk={handleClosePdfViewModal} onCancel={handleClosePdfViewModal}
        closeIcon={<MdClose />} width={800} centered>
        <iframe src={pdfUrl} title="" width={'100%'} height={'100%'} style={{ minHeight: '400px' }} />
      </Modal>
    </div>
  )
}

export default UserDetailsForm
